export const VAULT_DATA = {
  name: 'DesignCarat_Master_Drive',
  size: '912.4 GB',
  children: [
    {
      name: 'Bridal Rings',
      files: 847,
      size: '186.2 GB',
      children: [
        { name: 'Solitaire Collection', files: 312, size: '68.4 GB' },
        { name: 'Halo Settings', files: 248, size: '54.1 GB' },
        { name: 'Vintage & Art Deco', files: 189, size: '41.2 GB' },
        { name: 'Custom Band Profiles', files: 98, size: '22.5 GB' },
      ],
    },
    {
      name: 'Luxury Necklaces',
      files: 634,
      size: '142.8 GB',
      children: [
        { name: 'Pendant Designs', files: 286, size: '64.3 GB' },
        { name: 'Chain Links & Clasps', files: 198, size: '44.6 GB' },
        { name: 'Choker Templates', files: 150, size: '33.9 GB' },
      ],
    },
    {
      name: 'Earrings & Studs',
      files: 523,
      size: '118.6 GB',
      children: [
        { name: 'Drop Earrings', files: 187, size: '42.3 GB' },
        { name: 'Hoops & Huggie', files: 201, size: '45.5 GB' },
        { name: 'Stud Backs & Posts', files: 135, size: '30.8 GB' },
      ],
    },
    { name: 'Bracelets & Bangles', files: 412, size: '93.1 GB' },
    { name: 'Watch Components', files: 389, size: '87.4 GB' },
    { name: 'Gemstone Settings', files: 518, size: '116.9 GB' },
    { name: 'Mens Collection', files: 467, size: '105.2 GB' },
    { name: 'Export Templates', files: 210, size: '62.1 GB' },
  ],
};
